import { handleActions } from "redux-actions";
import * as Immutable from "immutable";
import * as Actions from "./uploadActions";
import { userLogoutReceived } from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: ""
});

//is action payload immutable?
export const uploadReducer = handleActions(
  {
    [Actions.uploadFileReceived](state, action) {
      return state.set("error", "");
    },
    [Actions.uploadFileFailed](state, action) {
      return state.set("error", action.payload);
    },
    [userLogoutReceived](state, action) {
      return initialState;
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/features/upload/store/uploadReducer.js